<div class="estimates-container" [formGroup]="estimateFormGroup" trackChanges>
    <div class="estimate-header-container">
        <div>
            <div class="estimate-input-container align-items-center">
                <div class="estimate-input-label-container pt-0">
                    <mat-label class="bold">{{ 'SELECTION' | translate}}:</mat-label>
                </div>
                <div class="right-align">
                    <mat-form-field appearance="outline" class="form-field-margin">
                        <input matInput [formControl]="estimateFormGroup.controls.selectionControl" >
                    </mat-form-field>
                </div>
            </div>
            <div class="estimate-input-container align-items-center">
                <div class="estimate-input-label-container pt-0">
                    <mat-label class="bold">{{ 'DESCRIPTION' | translate}}:</mat-label>
                </div>
                <div class="right-align">
                    <mat-form-field appearance="outline" class="form-field-margin">
                        <input matInput [formControl]="estimateFormGroup.controls.descriptionControl" >
                    </mat-form-field>
                </div>
            </div>
            <div class="estimate-input-container align-items-start">
                <div class="estimate-input-label-container d-flex gap-2 pt-0 align-items-center">
                    <img [src]="'./../../assets/images/Typical.JPG'" alt="" >
                    <mat-label class="bold">{{ 'TYPICAL_OF' | translate}}:</mat-label>
                </div>
                <div class="right-align">
                    <mat-form-field appearance="outline" class="form-field-margin number-input-width">
                        <input matInput value="0" disabled>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="width-300">
            <app-sol-estimate-totals
                [isMarkUpSelected]="isMarkUpSelected"
                [estimateFormGroup]="estimateFormGroup"
                [escalationTotal]="escalationTotal"
            ></app-sol-estimate-totals><br>
        </div>
    </div>

    <app-sol-estimate-table
        [estimateTableFormGroup]="estimateFormGroup"
        [taxVisibility]="solEstimateService.taxVisibility"
        (isMarkUpSelected)="setIsMarkUpSelected($event)"
    ></app-sol-estimate-table>

</div>